var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckVerifiedOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3869_23509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58434 8.77883L8.04753 10.242L11.3397 6.94984M5.36534 2.79344C5.95342 2.74651 6.51171 2.51526 6.96073 2.13261C8.00856 1.23965 9.54969 1.23965 10.5975 2.13261C11.0465 2.51526 11.6048 2.74651 12.1929 2.79344C13.5653 2.90295 14.655 3.9927 14.7645 5.36504C14.8114 5.95312 15.0427 6.51141 15.4253 6.96043C16.3183 8.00826 16.3183 9.5494 15.4253 10.5972C15.0427 11.0462 14.8114 11.6045 14.7645 12.1926C14.655 13.565 13.5653 14.6547 12.1929 14.7642C11.6048 14.8111 11.0465 15.0424 10.5975 15.4251C9.54969 16.318 8.00856 16.318 6.96073 15.4251C6.51171 15.0424 5.95342 14.8111 5.36534 14.7642C3.993 14.6547 2.90325 13.565 2.79373 12.1926C2.74681 11.6045 2.51555 11.0462 2.1329 10.5972C1.23995 9.5494 1.23995 8.00826 2.1329 6.96043C2.51555 6.51141 2.74681 5.95312 2.79373 5.36504C2.90325 3.9927 3.993 2.90295 5.36534 2.79344Z",
    stroke: "#F37721",
    strokeWidth: 1.72281,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3869_23509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5582,
    height: 17.5582,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckVerifiedOrange);
export default __webpack_public_path__ + "static/media/check-verified-orange.dab53a395bd72574173c2ba88a713146.svg";
export { ForwardRef as ReactComponent };